import { baseApi } from '../baseApi';
import { ListParams } from './academicYearApi';

export interface Note {
  id: string;
  title: string;
  description?: string | null;
  demoUrl: string;
  fullUrl: string;
  thumbnail?: string | null;
  isActive: boolean;
  chapterId: string;
  subjectId: string;
  academicYearId: string;
  classId: string;
  createdAt: string;
  updatedAt: string;
  chapter?: { name: string };
  subject?: { name: string };
}

export const noteApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotes: builder.query<{ success: boolean; data: Note[]; total: number }, ListParams | void>({
      query: (params) => ({
        url: '/api/notes',
        params: params || undefined,
      }),
      providesTags: ['Note'],
    }),
    createNote: builder.mutation<{ success: boolean; data: Note }, Partial<Note>>({
      query: (body) => ({
        url: '/api/notes',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Note', 'Dashboard'],
    }),
    updateNote: builder.mutation<{ success: boolean; data: Note }, { id: string; body: Partial<Note> }>({
      query: ({ id, body }) => ({
        url: `/api/notes/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Note', 'Dashboard'],
    }),
    deleteNote: builder.mutation<{ success: boolean; message: string }, string>({
      query: (id) => ({
        url: `/api/notes/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Note', 'Dashboard'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetNotesQuery,
  useCreateNoteMutation,
  useUpdateNoteMutation,
  useDeleteNoteMutation,
} = noteApi;
